import LogoPlaceholder from "./logo-placeholder.png";
import Slide1 from "./preview/slide-1.png";
import Slide2 from "./preview/slide-2.png";
import Slide3 from "./preview/slide-3.png";
import Slide4 from "./preview/slide-4.png";
import Slide5 from "./preview/slide-5.png";
import Avatar from "./basic-22-avatar.png";
import BgOption1 from "../images/bg-option-1.png";
import BgOption2 from "../images/bg-option-2.png";
import BgOption3 from "../images/bg-option-3.png";

import { MultilineView, TextView } from "../../components";
import BaseTemplate from "../base";

class Basic22 extends BaseTemplate {
  constructor() {
    super();
    this.name = "Basic #22";
    this.id = "22";
    this.url = "/ai/carousels/basic-22";
    this.description = "Create a carousel of images";
    this.common_settings = {
      elements: [
        {
          label: "Your Name",
          type: "text",
          value: "Jon Snow",
        },
        {
          label: "Profile Pic",
          type: "logo",
          key: "logo",
          value: {
            type: "image",
            image: Avatar,
          },
        },
        {
          label: "Handle",
          type: "text",
          value: "@jon-snow",
        },
        {
          label: "Background",
          type: "background",
          key: "background_color",
          value: {
            type: "color",
            image: "",
            color: "#27115F",
            color_options: [
              "#2cd4bf",
              "#38bcf7",
              "#feb022",
              "#f87066",
              "#33d583",
              "#818cf8",
              "#f471b6",
              "#bf84fc",
            ],
            image_options: [
              {
                image: BgOption1,
              },
              {
                image: BgOption2,
              },
              {
                image: BgOption3,
              },
            ],
          },
        },

        {
          label: "Primary Color",
          type: "color",
          key: "primary_color",
          style_key_group: "primary",
          value: "#D9D6FE",
        },
        {
          label: "Secondry Color",
          type: "color",
          key: "secondary_color",
          style_key_group: "secondary",
          value: "#FFFFFF",
        },
        {
          label: "Primary Font",
          key: "primary_font",
          value: "Onest",
          type: "font",
        },
        {
          label: "Secondary Font",
          key: "secondary_font",
          value: "Inter",
          type: "font",
        },
      ],
      swipe_indicator: {
        image: "",
      },
    };
    this.preview_images = [Slide1, Slide2, Slide3, Slide4, Slide5];
    this.slides = [
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "The Title of Your Visual Post Here",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "48px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "700",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Lorem ipsum: Lorem ipsum dolor sit amet, consetetur sadipscing.`,
            max_words: 15,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "20px",
              },
              fontFamily: {
                key: "secondary_font",
              },
              fontWeight: {
                value: "400",
              },
            },
          },
        ],
        slide_type: "intro",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "The Title Of Your Visual Post Here ",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "30px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "700",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Ipsum dolor: Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore.`,
            max_words: 15,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "16px",
              },
              fontFamily: {
                key: "secondary_font",
              },
              fontWeight: {
                value: "400",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "The Title Of Your Visual Post Here ",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "30px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "700",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Lorem ipsum: Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.`,
            max_words: 15,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "16px",
              },
              fontFamily: {
                key: "secondary_font",
              },
              fontWeight: {
                value: "400",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "The Title Of Your Visual Post Here ",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "30px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "700",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Ipsum dolor: Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore.`,
            max_words: 15,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "16px",
              },
              fontFamily: {
                key: "secondary_font",
              },
              fontWeight: {
                value: "400",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Sub CTA Text",
            type: "text",
            target_key: "cta_text",
            value: "Was this helpful?",
            max_words: 3,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "14px",
              },
              fontFamily: {
                key: "primary_font",
              },
              textAlign: {
                value: "center",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
          {
            label: "Sub CTA Text",
            type: "text",
            target_key: "cta_text",
            value: "Ask any questions in the comments.",
            max_words: 3,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "30px",
              },
              fontFamily: {
                key: "secondary_font",
              },
              textAlign: {
                value: "center",
              },
              fontWeight: {
                value: "700",
              },
            },
          },
          {
            label: "CTA Text",
            type: "text",
            target_key: "cta_text",
            value: "Like, share and save for later.",
            max_words: 3,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "16px",
              },
              fontFamily: {
                key: "primary_font",
              },
              textAlign: {
                value: "center",
              },
              fontWeight: {
                value: "500",
              },
            },
          },
        ],
        slide_type: "outro",
      },
    ];
  }

  setCommonSettings(settings) {
    this.common_settings = settings;
  }

  getPrimaryColor(common_settings) {
    return common_settings.elements[4].value;
  }

  getSecondaryColor(common_settings) {
    return common_settings.elements[5].value;
  }

  getBackgroundColor(common_settings) {
    return common_settings.elements[3].value.color;
  }

  getSecondaryColorVariant(common_settings) {
    return this.getSecondaryColor(common_settings) + "60";
  }

  getPrimaryFont(common_settings) {
    return common_settings.elements[6]?.value || "Onest";
  }

  getSecondaryFont(common_settings) {
    return common_settings.elements[7]?.value || "Inter";
  }

  duplicateSlide(slide, index) {
    let new_slide = JSON.parse(JSON.stringify(slide));
    this.slides.splice(index + 1, 0, new_slide);
    return new_slide;
  }

  renderOutroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div
          className="absolute w-[290px] h-[500px] top-[48px] left-[55px] rounded-t-full"
          style={{
            backgroundImage: `linear-gradient(${this.getSecondaryColor(
              commonSettings
            )}, transparent)`,
            opacity: "0.1",
          }}
        ></div>

        <img
          className="absolute top-[104px] left-[152px] object-cover w-[96px] h-[96px] rounded-full"
          src={
            commonSettings.elements[1].value.image
              ? commonSettings.elements[1].value.image
              : LogoPlaceholder
          }
          style={{
            backgroundColor: this.getPrimaryColor(commonSettings),
          }}
          alt=""
        />

        <div className="absolute inset-x-0 top-[232px] px-[36px] flex flex-col items-center gap-[20px]">
          {slide.elements[0]?.style ? (
            <MultilineView
              element={slide.elements[0]}
              getPropertyByStyleKey={(styleKey) =>
                this.getPropertyByStyleKey(styleKey, commonSettings)
              }
              getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
            />
          ) : (
            <TextView text={slide.elements[0]?.value} />
          )}

          {slide.elements[1]?.style ? (
            <MultilineView
              element={slide.elements[1]}
              getPropertyByStyleKey={(styleKey) =>
                this.getPropertyByStyleKey(styleKey, commonSettings)
              }
              getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
            />
          ) : (
            <TextView text={slide.elements[1]?.value} />
          )}
          <div className="w-[300px] flex flex-col items-center justify-center gap-2">
            {slide.elements[2]?.style ? (
              <MultilineView
                element={slide.elements[2]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[2]?.value} />
            )}

            <svg
              width="98"
              height="20"
              viewBox="0 0 98 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.8633 10.2715C20.8029 12.8956 19.7533 15.3646 17.6277 17.3557C16.6557 18.2662 15.5328 18.9393 14.2825 19.3929C12.9139 19.8904 11.4532 20.0826 10.0026 19.9559C8.55197 19.8292 7.14658 19.3867 5.88484 18.6595C5.78775 18.6036 5.70928 18.6213 5.61765 18.6548C4.43813 19.0849 3.25861 19.5167 2.07735 19.9408C1.72697 20.0665 1.40415 19.9904 1.13994 19.7286C0.872 19.463 0.796014 19.1375 0.92365 18.7815C1.35275 17.5835 1.78632 16.3871 2.22435 15.1924C2.23843 15.1587 2.24398 15.1221 2.24051 15.0857C2.23705 15.0494 2.22467 15.0144 2.20449 14.984C1.77595 14.2471 1.44593 13.457 1.22288 12.6342C0.934744 11.591 0.820392 10.5074 0.884416 9.42699C1.01487 7.27478 1.75726 5.36025 3.1116 3.68341C4.19751 2.34179 5.5516 1.35223 7.1555 0.712482C8.53102 0.160784 10.0126 -0.075481 11.4914 0.021055C15.3188 0.256582 18.6795 2.67595 20.1265 6.24166C20.6147 7.44389 20.8531 8.69681 20.8633 10.2715Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M56.0886 0.45459C53.0488 0.45459 51.3636 2.62897 51.3636 2.62897C51.3636 2.62897 49.6783 0.45459 46.6385 0.45459C43.4486 0.45459 40.8635 3.01598 40.8635 6.17663C40.8635 10.516 46.0211 14.7212 47.4586 16.0498C49.1144 17.5791 51.3636 19.5454 51.3636 19.5454C51.3636 19.5454 53.6127 17.5791 55.2685 16.0498C56.706 14.7212 61.8636 10.516 61.8636 6.17663C61.8636 3.01598 59.2785 0.45459 56.0886 0.45459Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M97.1367 18.4153C97.1367 18.8843 96.6036 19.1543 96.2255 18.8769L89.839 14.1911C89.6374 14.0433 89.3632 14.0433 89.1617 14.1911L82.7752 18.8769C82.3971 19.1543 81.864 18.8843 81.864 18.4153V1.0271C81.864 0.710912 82.1203 0.45459 82.4365 0.45459H96.5642C96.8803 0.45459 97.1367 0.710912 97.1367 1.0271V18.4153Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
            </svg>
          </div>
        </div>
      </>
    );
  }

  renderMiddleSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <div className="absolute inset-x-0 top-[88px] px-[24px] flex flex-col items-center gap-[20px]">
        <div className="flex flex-col gap-3">
          <div className="leading-[38px]">
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}
          </div>

          {slide.elements[1]?.style ? (
            <MultilineView
              element={slide.elements[1]}
              getPropertyByStyleKey={(styleKey) =>
                this.getPropertyByStyleKey(styleKey, commonSettings)
              }
              getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
            />
          ) : (
            <TextView text={slide.elements[1]?.value} />
          )}

          {slide.elements[2]?.value && (
            <img
              src={slide.elements[2].value}
              className="w-[352px] h-[180px] object-cover rounded-lg mt-4"
              alt=""
            />
          )}
        </div>
      </div>
    );
  }

  renderIntroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <div className="absolute inset-x-0 top-[88px] px-[24px] flex flex-col items-center gap-[20px]">
        <div className="flex flex-col gap-4">
          <div className="leading-[60px]">
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}
          </div>

          {slide.elements[1]?.style ? (
            <MultilineView
              element={slide.elements[1]}
              getPropertyByStyleKey={(styleKey) =>
                this.getPropertyByStyleKey(styleKey, commonSettings)
              }
              getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
            />
          ) : (
            <TextView text={slide.elements[1]?.value} />
          )}
        </div>
      </div>
    );
  }

  renderSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <div
        key={index}
        className={
          "carousel-slide-container ring-1 ring-gray-200 bg-white relative shrink-0 aspect-[4/5] flex flex-col items-center justify-center w-[400px] h-[500px] overflow-hidden " +
          (index !== currentSlide ? "hidden" : "") +
          " index-" +
          index
        }
        style={{
          fontFamily: this.getPrimaryFont(commonSettings),
        }}
      >
        <div className="absolute inset-0">
          {commonSettings.elements[3].value.type === "image" &&
            commonSettings.elements[3].value.image && (
              <img
                className="object-cover w-full h-full"
                src={commonSettings.elements[3].value.image}
                alt=""
              />
            )}
          {commonSettings.elements[3].value.type === "color" && (
            <div
              className="w-full h-full"
              style={{
                backgroundColor: this.getBackgroundColor(commonSettings),
              }}
            ></div>
          )}
        </div>
        {index === 0 &&
          this.renderIntroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index === carouselLength - 1 &&
          this.renderOutroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index !== carouselLength - 1 &&
          index !== 0 &&
          this.renderMiddleSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}

        {index !== carouselLength - 1 && (
          <>
            <div
              className="absolute top-[366px] left-0 w-[368px] h-[102px] rounded-r-full"
              style={{
                backgroundImage:
                  "linear-gradient(to right, transparent," +
                  this.getSecondaryColorVariant(commonSettings) +
                  ")",
              }}
            ></div>
            <div className="absolute top-[393px] left-[24px] flex items-center gap-3">
              <img
                className="object-cover w-[48px] h-[48px] rounded-full"
                src={
                  commonSettings.elements[1].value.image
                    ? commonSettings.elements[1].value.image
                    : LogoPlaceholder
                }
                style={{
                  backgroundColor: this.getPrimaryColor(commonSettings),
                }}
                alt=""
              />
              {index === 0 && (
                <p
                  className="text-[20px] leading-[30px] font-semibold "
                  style={{
                    color: this.getPrimaryColor(commonSettings),
                    fontFamily: this.getPrimaryFont(commonSettings),
                  }}
                >
                  {commonSettings.elements[0].value}
                </p>
              )}
            </div>

            <p
              className="absolute top-[40px] left-[24px] text-[16px] leading-[24px] font-medium "
              style={{
                color: this.getSecondaryColor(commonSettings),
                fontFamily: this.getPrimaryFont(commonSettings),
              }}
            >
              {commonSettings.elements[2].value}
            </p>

            <svg
              width="69"
              height="69"
              viewBox="0 0 69 69"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="absolute top-[382px] left-[271px]"
            >
              <path
                d="M3.44888 6.87646C5.35352 6.87646 6.89753 5.33711 6.89753 3.43823C6.89753 1.53935 5.35352 0 3.44888 0C1.54425 0 0.000232689 1.53935 0.000232689 3.43823C0.000232689 5.33711 1.54425 6.87646 3.44888 6.87646Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M13.6904 17.2956C15.5951 17.2956 17.1391 15.7562 17.1391 13.8574C17.1391 11.9585 15.5951 10.4191 13.6904 10.4191C11.7858 10.4191 10.2418 11.9585 10.2418 13.8574C10.2418 15.7562 11.7858 17.2956 13.6904 17.2956Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M13.6904 6.87646C15.5951 6.87646 17.1391 5.33711 17.1391 3.43823C17.1391 1.53935 15.5951 0 13.6904 0C11.7858 0 10.2418 1.53935 10.2418 3.43823C10.2418 5.33711 11.7858 6.87646 13.6904 6.87646Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M24.1413 17.2956C26.0459 17.2956 27.5899 15.7562 27.5899 13.8574C27.5899 11.9585 26.0459 10.4191 24.1413 10.4191C22.2366 10.4191 20.6926 11.9585 20.6926 13.8574C20.6926 15.7562 22.2366 17.2956 24.1413 17.2956Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M24.1413 27.5057C26.0459 27.5057 27.5899 25.9664 27.5899 24.0675C27.5899 22.1686 26.0459 20.6293 24.1413 20.6293C22.2366 20.6293 20.6926 22.1686 20.6926 24.0675C20.6926 25.9664 22.2366 27.5057 24.1413 27.5057Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M24.1413 6.87646C26.0459 6.87646 27.5899 5.33711 27.5899 3.43823C27.5899 1.53935 26.0459 0 24.1413 0C22.2366 0 20.6926 1.53935 20.6926 3.43823C20.6926 5.33711 22.2366 6.87646 24.1413 6.87646Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M34.3828 17.2956C36.2874 17.2956 37.8314 15.7562 37.8314 13.8574C37.8314 11.9585 36.2874 10.4191 34.3828 10.4191C32.4782 10.4191 30.9341 11.9585 30.9341 13.8574C30.9341 15.7562 32.4782 17.2956 34.3828 17.2956Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M34.3828 27.5057C36.2874 27.5057 37.8314 25.9664 37.8314 24.0675C37.8314 22.1686 36.2874 20.6293 34.3828 20.6293C32.4782 20.6293 30.9341 22.1686 30.9341 24.0675C30.9341 25.9664 32.4782 27.5057 34.3828 27.5057Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M34.3828 6.87646C36.2874 6.87646 37.8314 5.33711 37.8314 3.43823C37.8314 1.53935 36.2874 0 34.3828 0C32.4782 0 30.9341 1.53935 30.9341 3.43823C30.9341 5.33711 32.4782 6.87646 34.3828 6.87646Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M44.6243 17.2956C46.529 17.2956 48.073 15.7562 48.073 13.8574C48.073 11.9585 46.529 10.4191 44.6243 10.4191C42.7197 10.4191 41.1757 11.9585 41.1757 13.8574C41.1757 15.7562 42.7197 17.2956 44.6243 17.2956Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M44.6243 27.5057C46.529 27.5057 48.073 25.9664 48.073 24.0675C48.073 22.1686 46.529 20.6293 44.6243 20.6293C42.7197 20.6293 41.1757 22.1686 41.1757 24.0675C41.1757 25.9664 42.7197 27.5057 44.6243 27.5057Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M34.3828 37.7164C36.2874 37.7164 37.8314 36.1771 37.8314 34.2782C37.8314 32.3793 36.2874 30.84 34.3828 30.84C32.4782 30.84 30.9341 32.3793 30.9341 34.2782C30.9341 36.1771 32.4782 37.7164 34.3828 37.7164Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M44.6243 37.7164C46.529 37.7164 48.073 36.1771 48.073 34.2782C48.073 32.3793 46.529 30.84 44.6243 30.84C42.7197 30.84 41.1757 32.3793 41.1757 34.2782C41.1757 36.1771 42.7197 37.7164 44.6243 37.7164Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M24.1412 48.1355C26.046 48.1355 27.5901 46.596 27.5901 44.697C27.5901 42.798 26.046 41.2585 24.1412 41.2585C22.2365 41.2585 20.6924 42.798 20.6924 44.697C20.6924 46.596 22.2365 48.1355 24.1412 48.1355Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M34.3828 48.1355C36.2876 48.1355 37.8317 46.596 37.8317 44.697C37.8317 42.798 36.2876 41.2585 34.3828 41.2585C32.4781 41.2585 30.9339 42.798 30.9339 44.697C30.9339 46.596 32.4781 48.1355 34.3828 48.1355Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M44.6243 48.1355C46.5291 48.1355 48.0732 46.596 48.0732 44.697C48.0732 42.798 46.5291 41.2585 44.6243 41.2585C42.7196 41.2585 41.1754 42.798 41.1754 44.697C41.1754 46.596 42.7196 48.1355 44.6243 48.1355Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M13.6904 58.3588C15.5951 58.3588 17.1391 56.8195 17.1391 54.9206C17.1391 53.0217 15.5951 51.4824 13.6904 51.4824C11.7858 51.4824 10.2418 53.0217 10.2418 54.9206C10.2418 56.8195 11.7858 58.3588 13.6904 58.3588Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M24.1413 58.3588C26.0459 58.3588 27.5899 56.8195 27.5899 54.9206C27.5899 53.0217 26.0459 51.4824 24.1413 51.4824C22.2366 51.4824 20.6926 53.0217 20.6926 54.9206C20.6926 56.8195 22.2366 58.3588 24.1413 58.3588Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M34.3828 58.3588C36.2874 58.3588 37.8314 56.8195 37.8314 54.9206C37.8314 53.0217 36.2874 51.4824 34.3828 51.4824C32.4782 51.4824 30.9341 53.0217 30.9341 54.9206C30.9341 56.8195 32.4782 58.3588 34.3828 58.3588Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M44.6243 58.3588C46.529 58.3588 48.073 56.8195 48.073 54.9206C48.073 53.0217 46.529 51.4824 44.6243 51.4824C42.7197 51.4824 41.1757 53.0217 41.1757 54.9206C41.1757 56.8195 42.7197 58.3588 44.6243 58.3588Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M55.297 27.5057C57.2017 27.5057 58.7457 25.9664 58.7457 24.0675C58.7457 22.1686 57.2017 20.6293 55.297 20.6293C53.3924 20.6293 51.8484 22.1686 51.8484 24.0675C51.8484 25.9664 53.3924 27.5057 55.297 27.5057Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M55.297 37.7164C57.2017 37.7164 58.7457 36.1771 58.7457 34.2782C58.7457 32.3793 57.2017 30.84 55.297 30.84C53.3924 30.84 51.8484 32.3793 51.8484 34.2782C51.8484 36.1771 53.3924 37.7164 55.297 37.7164Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M55.297 48.1355C57.2018 48.1355 58.7459 46.596 58.7459 44.697C58.7459 42.798 57.2018 41.2585 55.297 41.2585C53.3922 41.2585 51.8481 42.798 51.8481 44.697C51.8481 46.596 53.3922 48.1355 55.297 48.1355Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M3.44888 69C5.35365 69 6.89777 67.4605 6.89777 65.5615C6.89777 63.6625 5.35365 62.1231 3.44888 62.1231C1.54412 62.1231 0 63.6625 0 65.5615C0 67.4605 1.54412 69 3.44888 69Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M13.6904 69C15.5952 69 17.1393 67.4605 17.1393 65.5615C17.1393 63.6625 15.5952 62.1231 13.6904 62.1231C11.7857 62.1231 10.2415 63.6625 10.2415 65.5615C10.2415 67.4605 11.7857 69 13.6904 69Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M24.1412 69C26.046 69 27.5901 67.4605 27.5901 65.5615C27.5901 63.6625 26.046 62.1231 24.1412 62.1231C22.2365 62.1231 20.6924 63.6625 20.6924 65.5615C20.6924 67.4605 22.2365 69 24.1412 69Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M34.3828 69C36.2876 69 37.8317 67.4605 37.8317 65.5615C37.8317 63.6625 36.2876 62.1231 34.3828 62.1231C32.4781 62.1231 30.9339 63.6625 30.9339 65.5615C30.9339 67.4605 32.4781 69 34.3828 69Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M65.5514 37.7164C67.456 37.7164 69 36.1771 69 34.2782C69 32.3793 67.456 30.84 65.5514 30.84C63.6467 30.84 62.1027 32.3793 62.1027 34.2782C62.1027 36.1771 63.6467 37.7164 65.5514 37.7164Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
            </svg>
          </>
        )}
      </div>
    );
  }
}

export default Basic22;
